import { render, staticRenderFns } from "./Academia_component.vue?vue&type=template&id=af483e04&scoped=true"
import script from "./Academia_component.vue?vue&type=script&lang=js"
export * from "./Academia_component.vue?vue&type=script&lang=js"
import style0 from "./Academia_component.vue?vue&type=style&index=0&id=af483e04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af483e04",
  null
  
)

export default component.exports